module.exports = __webpack_public_path__ + "img/purpleheart-swatch.696e6ee1.png";